import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  inject,
} from '@angular/core';
import {
  EmailInputBuilderWrapper,
  InputComponentWrapper,
} from '../../constants';
import { ValidationService } from '../../ui-components/validation.service';

@Component({
  selector: 'conn-email-input-builder',
  templateUrl: './email-input-builder.component.html',
  styleUrls: ['./email-input-builder.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EmailInputBuilderComponent implements OnChanges {
  private validationService = inject(ValidationService);

  @Input() initialEmails: string[];
  @Input() submitted: boolean;
  @Input() required: boolean;
  @Output() currentEmails: EventEmitter<EmailInputBuilderWrapper>;
  emailArray: InputComponentWrapper[];
  hasBeenInitialized: boolean;

  constructor() {
    this.currentEmails = new EventEmitter<EmailInputBuilderWrapper>();
    this.emailArray = [new InputComponentWrapper()];
    this.hasBeenInitialized = false;
  }

  ngOnChanges() {
    if (!this.initialEmails) {
      this.initialEmails = [''];
    } else if (!this.hasBeenInitialized) {
      // only run this once
      this.hasBeenInitialized = true;
      this.emailArray = [];
      for (const email of this.initialEmails) {
        this.emailArray.push({
          inputText: email,
          isValid: this.isEmailValid(email),
        } as InputComponentWrapper);
      }
      this.validationService.setEmailArray(this.emailArray);
    }
  }

  setEmailBuilderValue(index: number, emailAddress: InputComponentWrapper) {
    this.emailArray[index].inputText = emailAddress.inputText;
    this.emailArray[index].isValid = emailAddress.isValid;
    this.validationService.setEmailArray(this.emailArray);
    const isValid = this.validationService.isEmailBuilderValid();
    this.currentEmails.emit({
      emailCollection: this.emailArray,
      isValid: isValid,
    });
  }

  addEmail() {
    const newEmail = new InputComponentWrapper();
    this.emailArray.push(newEmail);
    this.setEmailBuilderValue(this.emailArray.length - 1, newEmail);
  }

  removeEmail(index?: number) {
    if (this.emailArray.length > 1) {
      this.emailArray.splice(index, 1);
      this.setEmailBuilderValue(
        this.emailArray.length - 1,
        this.emailArray[this.emailArray.length - 1],
      );
    }
  }

  /**
   * Cannot find a better way of doing this without duplicating code.  When loading in multiple emails only using the
   * lifecycle OnChange seems to work however this is triggered before a ViewChild component would become active.
   * This means at the time of loading there is no way to call email-input.component to see if the email string we
   * are given at load time is a valid email or not.  By duplicating this function we can validate a string when we
   * get it.
   * @returns {boolean}
   */
  isEmailValid(email: string): boolean {
    return this.validationService.isEmailValid(email);
  }
}
